import React, { useContext, useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import Meta from "../components/Meta";
import Loader from "../components/Loader";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.min.css";
import { AuthContext } from "../store/AuthContext";
import api from "../services/api";
import SescServices from "../services/handleSesc";
import ContainerHome from "../components/ContainerHome";
import { Button, Form, Modal, Row } from "react-bootstrap";
import Choice from "../screens/ChoiceScreen";
import DocumentsScreen from "./DocumentsScreen";

const HomeScreen = () => {
  const [errors] = useState(false);
  const { handleLogout, timer } = useContext(AuthContext);
  // eslint-disable-next-line
  const [loading, setLoading] = useState(false);
  const [show, setShow] = useState(true);
  const [card, setCard] = useState(false);
  const [sendoc, setSendoc] = useState(false);
  const [opcao, setOpcao] = useState("");
  const userInfo = JSON.parse(localStorage.getItem("userInfo"));
  const history = useHistory();

  /*
    
      FUNÇÕES AUXILIARES  

    */

  // CONFIRMAÇÃO DO PESQUISA DA CRENDENCIAL
  const handleClick = () => {
    localStorage.removeItem("userInfo");
    localStorage.removeItem("token");
    localStorage.removeItem("cart");
    api.defaults.headers.Authorization = undefined;
    history.push("/login");
  };

  const pesquisaCard = async () => {
    
    setLoading(true);
    
    
    const todayDate = new Date().toISOString().slice(0, 10);
    const cliente = await SescServices.helper2(userInfo);
    
    if (cliente.DTVENCTO < todayDate) {
      const config = { headers: { "Content-Type": "application/json" } };
      await api.put("/api/users/cardvecto", { nucpf: userInfo.cpf }, config);
    }

    const config = { headers: { "Content-Type": "application/json" } };
    const resp = await api.post(
      "/api/users/cardx",
      { nucpf: userInfo.cpf },
      config
    );

    if (resp.data.cardConfirmado === true) {
      setCard(true);
      setLoading(false);
      history.push("/credencial");
      // eslint-disable-next-line
    } else if (resp.data.sendoc == process.env.REACT_APP_SENDOC) {
      setSendoc(true);
      setCard(false);
      setLoading(false);
    } else {
      setCard(false);
      setLoading(false);
    }
  };

  //OPÇÃO ESCOLHIDA
  const handleConfirmacao = async (e) => {
    if (opcao === "S") {
      pesquisa();
      setShow(false);
    } else {
      setShow(false);
    }
  };

  //CONFIRMAÇÃO DO CREDENCIAL
  const confirmedCard = async (cpfx) => {
    const config = {
      headers: { "Content-Type": "application/json" },
    };
    const resp = await api.put("/api/users/cardx", { nucpf: cpfx }, config);
    if (resp.data.tkconfirmado) {
      history.push("/credencial");
    }
  };

  //CONFIRMAÇÃO DO PESQUISA DA CRENDENCIAL
  const pesquisa = async () => {
    const dtAtual = new Date().toISOString().slice(0, 10);
    const resp = await SescServices.helper2(userInfo);

    if (resp.DTVENCTO < dtAtual) {
      if (resp.SQTITULMAT != null) {
        setOpcao("DEP");
        setShow(false);
        toast.error("Carteira Dependente Vencida");
      } else {
        setOpcao("N");
        setShow(false);
        toast.error("Carteira Vencida");
      }
    } else {
      /*fazer alteração do banco de dados  */
      confirmedCard(resp.NUCPF);
    }
  };

  useEffect(() => {
    if (userInfo.cpf) {
      pesquisaCard();
    }
    // eslint-disable-next-line
  }, []);

  if (timer === 0) {
    handleLogout();
  }
  if (timer < 3) {
    return (
      <>
        <p className="text-white">
          Em {timer} segundos, você será desconectado automaticamente...
        </p>
      </>
    );
  }

  return (
    <>
      <ToastContainer />
      <Meta />
      <ContainerHome>
        {loading ? (
          <Loader />
        ) : errors ? (
          <div>erro</div>
        ) : (
          <>
            {card === false && sendoc === false ? (
              <>
                <Row>
                  <Modal
                    show={show}
                    data-toggle="modal"
                    data-backdrop="static"
                    data-keyboard="false"
                  >
                    <Modal.Header>
                      <Modal.Title>Já possui credencial do SESC ?</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                      <Form.Check
                        inline
                        label="SIM"
                        name="group1"
                        type="radio"
                        value="S"
                        id={`default-radio-1`}
                        onChange={(e) => setOpcao(e.target.value)}
                      />
                      <Form.Check
                        inline
                        label="NÃO"
                        name="group1"
                        type="radio"
                        value="N"
                        id={`default-radio-2`}
                        onChange={(e) => setOpcao(e.target.value)}
                      />
                    </Modal.Body>
                    <Modal.Footer>
                      <Button
                        variant="warning"
                        className="text-dark"
                        onClick={handleConfirmacao}
                      >
                        Confirmar
                      </Button>
                    </Modal.Footer>
                  </Modal>
                </Row>
              </>
            ) : (
              <>
                <DocumentsScreen />
              </>
            )}
          </>
        )}

        {opcao === "N" && show === false ? (
          <>
            <Choice />
          </>
        ) : null}

        {opcao === "DEP" && show === false ? (
          <>
            <ContainerHome>
              <div className="card o-hidden border-0 shadow-lg my-5">
                <div className="card-body p-0">
                  <div className="row text-center">
                    <img
                      src="img/dependente.jpg"
                      className="img-fluid"
                      width="100%"
                      height="80%"
                      alt="Dependente"
                    />

                    <Button
                      className="btn btn-warning btn-lg mt-3 mb-5"
                      onClick={handleClick}
                    >
                      {" "}
                      <i className="fas fa-angle-left"></i> Clique aqui para
                      Retornar{" "}
                    </Button>
                  </div>
                </div>
              </div>
            </ContainerHome>
          </>
        ) : null}
      </ContainerHome>
    </>
  );
};

export default HomeScreen;
